import React from 'react';
import UploadIcon from '../icons/upload.svg';

const BannerUploadBox = ({ handleClick, preview, onClear, className, style }) => {
  return (
    <div
      className={`flex items-center justify-between p-4 rounded-lg cursor-pointer ${className || ''}`}
      style={{
        ...style,
        background: 'var(--input-bg)',
        border: '1px solid var(--input-border)'
      }}
      onClick={handleClick}
    >
      {preview ? (
        <>
          <img
            src={preview}
            alt="Banner Preview"
            className="w-24 h-16 object-cover rounded"
          />
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClear();
            }}
            className="px-3 py-1 rounded text-sm font-medium"
            style={{
              background: 'var(--button-secondary-bg)',
              color: 'var(--button-secondary-text)',
              border: '1px solid var(--button-secondary-border)'
            }}
          >
            Clear
          </button>
        </>
      ) : (
        <>
          <span style={{ color: 'var(--input-color)' }}>Upload banner</span>
          <img
            src={UploadIcon}
            alt="Upload"
            className="w-5 h-5"
            style={{ filter: 'var(--icon-filter)' }}
          />
        </>
      )}
    </div>
  );
};

export default BannerUploadBox;
